module.exports = __webpack_public_path__ + "img/sweetx-javaEE-project.1a68f925.png";